import { connect } from 'react-redux';
import {
  createInventoryTags,
  fetchInventoryTags
} from '../../../redux/Inventory/sagas/tag/routines';
import { clearIventoryTags } from '../../../redux/Inventory/actions/tag';
import {
  showAddInventoryTagsModal,
  hideAddInventoryTagsModal
} from '../../../redux/actions/views/inventory/tags';
import {
  getIsSaving,
  getShowAddTagsModal
} from '../../../redux/selectors/views/inventory/tags';
import { getIsFetching } from '../../../redux/Inventory/selectors/tag';
import InventoryTags from './component';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';

function mapStateToProps(state) {
  const query = getSearchQueryForContext(state, SEARCH_CONTEXT.TAG);
  return {
    query,
    isSaving: getIsSaving(state),
    isFetching: getIsFetching(state),
    showAddTagsModal: getShowAddTagsModal(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: tags => {
      dispatch(createInventoryTags(tags));
    },
    onShowAddTagsModal: () => {
      dispatch(showAddInventoryTagsModal());
    },
    onHideAddTagsModal: () => {
      dispatch(hideAddInventoryTagsModal());
    },
    resetViewState: () => {
      dispatch(clearIventoryTags());
      dispatch(fetchInventoryTags());
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryTags);
